/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.

const config = {
	"sitecoreApiKey": "#{sitecoreApiKey}",
	"sitecoreApiHost": "#{sitecoreApiHost}",
	"jssAppName": "#{jssAppName}",
	"defaultLanguage": "#{defaultLanguage}",
	"graphQLEndpointPath": "#{graphQLEndpointPath}",
	"sessionTime": "#{sessionTime}",
	"endpoints": {
		"callback": "#{endpoints.callback}",
		"content": "#{endpoints.content}",
		"quotes": "#{endpoints.quotes}",
		"postcodeValidation": "#{endpoints.postcodeValidation}",
		"bankValidation": "#{endpoints.bankValidation}",
		"apply": "#{endpoints.apply}"
	},
	"recaptcha": {
		"sitekey": "#{recaptcha.sitekey}",
		"toggle": "#{recaptcha.toggle}"
	},
	"referenceData": {
		"addressFormat": "#{referenceData.addressFormat}",
		"systemEntityNumber": "#{referenceData.systemEntityNumber}"
	},
	"analytics": {
		"sitekey": "#{analytics.sitekey}"
	},
	"urls": {
		"firstPage": "#{urls.firstPage}",
		"pageNotFound": "#{urls.pageNotFound}",
		"retrieve": "#{urls.retrieve}",
		"successPage": "#{urls.successPage}",
		"serviceDown": "#{urls.serviceDown}"
	},
	"engageParams": {
		"clientKey": "#{engageParams.clientKey}",
		"targetURL": "#{engageParams.targetURL}",
		"pointOfSale": "#{engageParams.pointOfSale}",
		"cookieDomain": "#{engageParams.cookieDomain}",
		"cookieExpiryDays": "#{engageParams.cookieExpiryDays}",
		"forceServerCookieMode": "#{engageParams.forceServerCookieMode}",
		"includeUTMParameters": "#{engageParams.includeUTMParameters}",
		"webPersonalization": "#{engageParams.webPersonalization}"
	}
};

config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports = config;